var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "#4C5C5A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2069 8.5861L15.4144 5.79297C15.3215 5.70009 15.2113 5.62641 15.0899 5.57614C14.9686 5.52587 14.8385 5.5 14.7072 5.5C14.5759 5.5 14.4458 5.52587 14.3245 5.57614C14.2031 5.62641 14.0929 5.70009 14 5.79297L6.29313 13.5005C6.19987 13.593 6.12593 13.7031 6.0756 13.8245C6.02528 13.9458 5.99959 14.076 6.00001 14.2073V17.0005C6.00001 17.2657 6.10536 17.52 6.2929 17.7076C6.48043 17.8951 6.73479 18.0005 7.00001 18.0005H9.79313C9.9245 18.0009 10.0546 17.9752 10.176 17.9249C10.2973 17.8746 10.4075 17.8006 10.5 17.7073L18.2069 10.0005C18.2998 9.90761 18.3734 9.79736 18.4237 9.67602C18.474 9.55468 18.4999 9.42463 18.4999 9.29329C18.4999 9.16195 18.474 9.03189 18.4237 8.91055C18.3734 8.78921 18.2998 8.67896 18.2069 8.5861ZM16 10.793L13.2069 8.00047L14.7069 6.50047L17.5 9.29297L16 10.793Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditAvatar);
export default __webpack_public_path__ + "static/media/edit-avatar.f9f067672ded03ed094a8818b4a2b523.svg";
export { ForwardRef as ReactComponent };